
import React, { useEffect } from "react";
import { Field } from "redux-form";
import { renderField } from "../../Utils/renderField";
import { renderNumber } from "../../Utils/renderField/renderField";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

const renderContactPerson = ({
    fields,
    meta: { touched, error, submitFailed },
    isView,
}) => {
    useEffect(() => {
        fields.push({});
    }, []);

    return (
        <React.Fragment>
            <div className="col-12 col-md-6 form-group d-flex align-items-end">
                <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => fields.push({})}
                >
                    Agregar Persona de Contacto
                </button>
            </div>
            <div
                className="col-12 form-group"
                style={{ minHeight: `${fields.length * 50 + 150}px` }}
            >
                {fields.length > 0 ? (
                    <React.Fragment>
                        {/* Desktop View (Table) */}
                        <div className="d-none d-md-block table-responsive">
                            <Table className="table">
                                <Thead>
                                    <Tr className="table-primary text-white">
                                        <Th>#</Th>
                                        <Th>Nombre <small className="text-muted">(Opcional)</small></Th>
                                        <Th style={{ width: '250px' }}>Teléfono <small className="text-muted">(Opcional)</small></Th>
                                        <Th>Acciones</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {fields.map((member, index) => (
                                        <Tr key={index}>
                                            <Td>{index + 1}</Td>
                                            <Td>
                                                <Field
                                                    name={`${member}.name`}
                                                    placeholder="Nombre"
                                                    type="text"
                                                    disabled={isView}
                                                    component={renderField}
                                                />
                                            </Td>
                                            <Td>
                                                <Field
                                                    name={`${member}.phone_number`}
                                                    numberFormat={"+(502) ####-####"}
                                                    placeholder="Teléfono"
                                                    type="text"
                                                    disabled={isView}
                                                    component={renderNumber}
                                                />
                                            </Td>
                                            <Td>
                                                {!isView && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-remove-custom"
                                                        onClick={() => fields.remove(index)}
                                                    >
                                                        <span className="material-icons">close</span>
                                                    </button>
                                                )}
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </div>

                        {/* Mobile View (Cards) */}
                        <div className="d-md-none vehicle-card-container">
                            {fields.map((member, index) => (
                                <div key={index} className="vehicle-card">
                                    <span className="vehicle-card-header">{index + 1}</span>

                                    <div className="vehicle-field-row">
                                        <label className="vehicle-field-label">Nombre <small className="text-muted">(Opcional)</small></label>
                                        <div className="vehicle-field-value">
                                            <Field
                                                name={`${member}.name`}
                                                placeholder="Nombre"
                                                type="text"
                                                disabled={isView}
                                                component={renderField}
                                            />
                                        </div>
                                    </div>

                                    <div className="vehicle-field-row">
                                        <label className="vehicle-field-label">Teléfono <small className="text-muted">(Opcional)</small></label>
                                        <div className="vehicle-field-value">
                                            <Field
                                                name={`${member}.phone_number`}
                                                numberFormat={"+(502) ####-####"}
                                                placeholder="Teléfono"
                                                type="text"
                                                disabled={isView}
                                                component={renderNumber}
                                            />
                                        </div>
                                    </div>

                                    {!isView && (
                                        <div className="vehicle-field-row">
                                            <label className="vehicle-field-label">Acciones</label>
                                            <div className="vehicle-field-value">
                                                <button
                                                    type="button"
                                                    className="btn btn-remove-custom"
                                                    onClick={() => fields.remove(index)}
                                                >
                                                    <span className="material-icons">close</span>
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </React.Fragment>
                ) : (
                    <p>Presione el botón 'Agregar Persona de Contacto'.</p>
                )}
            </div>
        </React.Fragment>
    );
};

export default renderContactPerson;
